<template>
    <tile link="official-code">
        <tile-title slot="tileHeader" icon="map-o">Официальные коды</tile-title>
        <div class="table-container" slot="tileContent" ref="htmlContent">
            <table v-if="codesList.length > 0" class="codes-table">
                <tbody>
                    <tr v-for="(c, i) in  codesList" :key="i">
                        <td class="codes-first-column" v-if="codesData[c].code">{{ getRussianCodeName(c, type) }}</td>
                        <td v-if="codesData[c].code">
                            {{ codesData[c].code }}
                            <span v-if="codesData[c].descr"> - {{ codesData[c].descr }}</span>
                            <span v-if="codesData[c].date">({{ codesData[c].date }})</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="btn-container" slot="tileFooter">
            <tilePrintPdf
                :html="htmlForPrint"
                :title="title"
                :printStyle="printStyle"
                filename="Official_codes" 
            />
        </div>
    </tile>
</template>

<script>
import tile from '@/components/ui/tile/tile.vue'
import tileTitle from '@/components/ui/tileTitle/tileTitle.vue'
import tilePrintPdf from '@/components/ui/tilePrintPdf/tilePrintPdf.vue'
export default {
    components: {
        tile,
        tileTitle,
        tilePrintPdf
    },
    data: () => ({
        htmlForPrint: '',
        printStyle: `
            .print-main-title { 
                    border-bottom: 1px solid #4b6365;
                    color: #4b6365;
                    font-size: 25px;
                    margin-top: 0px;
                    margin-bottom: 0px;
                    text-align: center;
                    margin-bottom: 15px;
                    margin-top: 20px; 
                }
            .codes-table td { text-align: center; padding: 8px;}
            .codes-first-column { padding: 10px 20px; font-weight: 700;  background: #ddddde; }
        `
    }),
    computed: {
        codesData() { return this.$store.state?.card?.company?.codes_data },
        codesList() { return Object.keys(this.codesData ?? {}) },
        companyName() {
            if(this.type === 'ip') {
                return this.$store.state.card?.company?.head_fio ? `ИП ${this.$store.state.card?.company?.head_fio}` : this.$store.state.card?.company?.title
            } else {
                return this.$store.state?.card?.company?.name_short || this.$store.state?.card?.company?.name_full
            }
        },
        title() { return `Официальные коды | ${this.companyName}` },
        type() { return this.$store.state.card?.company?.type }
    },
    mounted() {
        if(this.codesList?.length > 0) {
            this.htmlForPrint = this.$refs.htmlContent?.innerHTML
        }
    }
}
</script>

<style lang="sass" scoped>

.table-container
    padding-top: 15px
.codes-table
    width: 100%
    td
        font-size: 13px
        line-height: 18px
        padding: 8px
    .codes-first-column
        font-weight: 700
.btn-container
    display: flex
    justify-content: flex-end

</style>